import React from 'react';
import { bool, func, string } from 'prop-types';
import classnames from 'classnames';
import './StrategyCard.scss';

StrategyCard.propTypes = {
  description: string,
  disabled: bool,
  handleStrategyCardClick: func,
  icon: string,
  id: string,
  title: string
};

function StrategyCard(props) {
  const { description, disabled, handleStrategyCardClick, icon, id, title } = props;
  return (
    <div className={classnames('landing-page__card', { disabled })} onClick={() => handleStrategyCardClick(id)}>
      <i className={classnames('left-panel', icon)} />
      <div className="right-panel">
        <div className="card-title">
          {title}
          {disabled && <span className="card__warning">Coming Soon</span>}
        </div>
        <div className="card-description">{description}</div>
      </div>
    </div>
  );
}

export default StrategyCard;
